import React from 'react';
import AtlasV2MetricSpineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricSpineChart';
import useAtlasV2KeywordSearchRequestBuilder from 'src/components/AtlasV2Components/AtlasV2Sidebar/AtlasV2SearchSidebar/useAtlasV2KeywordSearchRequestBuilder';

import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

/**
 * AtlasV2 Organic traffic spline chart for the keywords search page
 */
const AtlasV2KeywordSearchOrganicTrafficSpline = ({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) => {
  const keywordSearchRequestBuilder = useAtlasV2KeywordSearchRequestBuilder();
  const builderForRequest = builderFunction || keywordSearchRequestBuilder;

  return <AtlasV2MetricSpineChart indexName="traffic" fieldName="organicClicks" requestBuilder={builderForRequest()} />;
};

export default AtlasV2KeywordSearchOrganicTrafficSpline;
